import type { ArticleInput } from '../../types';

interface Props {
  slot: 'A' | 'B';
  value: ArticleInput;
  maxChars: number;
  titleError?: string;
  bodyError?: string;
  onChange: (value: ArticleInput) => void;
}
export function ArticleEditor({ slot, value, maxChars, titleError, bodyError, onChange }: Props) {
  return (
    <section className="article-box" aria-labelledby={`article-${slot}-label`}>
      <h3 id={`article-${slot}-label`}>文章 {slot}</h3>
      <label>
        文章标题
        <input
          value={value.title}
          maxLength={500}
          aria-invalid={!!titleError}
          onChange={(e) => onChange({ ...value, title: e.target.value })}
          placeholder={slot === 'A' ? '请输入文章标题' : '请输入对比版本标题'}
        />
      </label>
      {titleError && <span className="field-error">{titleError}</span>}
      <label>
        文章正文
        <textarea
          value={value.body}
          aria-invalid={!!bodyError}
          onChange={(e) => onChange({ ...value, body: e.target.value })}
          placeholder="粘贴完整文章正文，正文仅用于本次评测"
        />
      </label>
      <div className="field-meta">
        <span className={value.body.length > maxChars ? 'danger' : ''}>
          {value.body.length.toLocaleString()} / {maxChars.toLocaleString()} 字
        </span>
        {bodyError && <span className="field-error">{bodyError}</span>}
      </div>
    </section>
  );
}
